import { Button, Dropdown, type MenuProps } from '@/components';
import { DownOutlined } from '@ant-design/icons';
import { type ComponentProps, isValidElement } from 'react';
import { useTranslation } from 'react-i18next';

type DropdownSubmitButtonProps<K extends string> = {
  menuItems: Array<{ key: K; label: string }>;
  text?: string;
  onClick?: (e: { key: K }) => void | Promise<void>;
} & Pick<ComponentProps<typeof Dropdown.Button>, 'loading' | 'disabled'>;

export const DropdownSubmitButton = <K extends string>({
  menuItems,
  text,
  onClick,
  loading,
  disabled,
}: DropdownSubmitButtonProps<K>) => {
  const { t } = useTranslation();

  const handleClick: MenuProps['onClick'] = (info) => {
    if (onClick) {
      const customInfo = { key: info.key as K };
      onClick(customInfo);
    }
  };

  return (
    <Dropdown.Button
      type="primary"
      htmlType="submit"
      loading={loading}
      disabled={disabled}
      icon={<DownOutlined />}
      menu={{
        items: menuItems,
        onClick: handleClick,
      }}
      trigger={['click']} // NOTE: for accessibility
      autoFocus
      buttonsRender={([submitButton, menuButton]) => {
        return [
          <Button
            key={0}
            {...(isValidElement(submitButton) && submitButton.props)}
          >
            {text ?? t('save')}
          </Button>,
          menuButton,
        ];
      }}
    />
  );
};
